module.exports = __webpack_public_path__ + "assets/img/sidebar_menu_open.ba28e278.svg";